export const emailRegex = /^[a-z0-9_.%+\-]+@[a-z0-9_.\-]+[.][a-z]{2,}$/iv;
